import { useTypeSelector } from './useTypeHooks';
export var useCheckForLimit = function (report) {
    var blockedReports = useTypeSelector(function (state) { return state.view.blockedReports; });
    return blockedReports.filter(function (item) { return item.includes(report); }).length > 0;
};
